/* eslint-disable react/jsx-props-no-spreading */
import _ from "lodash";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useCongress, useUserMe } from "../hooks";

const PrivateRoute = ({ children, roles = [], availableUnpublished = false, path, ...rest }) => {
  const { congress } = useCongress();
  const { user } = useUserMe();

  /* Check if user is logged in */
  if (!user.loaded) return <Redirect to="/login" />;

  /* Check if congress need terms acceptance */
  if (path !== "/terms" && congress.termsAcceptanceMandatory && !user?.profile?.termsAcceptance) {
    return <Redirect to="/terms" />;
  }

  /* Check if requested page is available when congress is not published or started */
  if (!user.hasRoles(["admin", "organizer"]) && !availableUnpublished && !congress.open) {
    return <Redirect to="/count-down" />;
  }

  /* Check if user needs role to access requested page */
  if (_.isEmpty(roles)) {
    return <Route {...rest}>{children}</Route>;
  }
  if (user.loaded && user.hasRoles(roles)) {
    return <Route {...rest}>{children}</Route>;
  }

  return <Redirect to="/login" />;
};

export default PrivateRoute;
